// extracted by mini-css-extract-plugin
module.exports = {"title":"CollectorsSection_title___Q5UH","result":"CollectorsSection_result__YR_PW"};